import CommonUtil from "./CommonUtil";

import PartySession from "../session/PartySession";
import {constants} from "./Constants";

class SecurityUtils {
  static checkPartyHasAnyOfProcesses = processes => {
    if (processes && processes.length > 0) {
      const authorities = PartySession.getParty()?.authorities;
      if (authorities) {
        for (let i = 0; i < processes.length; i++) {
          const process = processes[i];
          if (
            CommonUtil.arrayHasObjectWithProperty(
              authorities,
              "authority",
              process
            )
          ) {
            return true;
          }
        }
      }
    } else {
      return true;
    }
    return false;
  };

  static checkSameParty = entityPartyId => {
    if (entityPartyId) {
      const partyPartyId = PartySession.getParty()?.id;
      return partyPartyId === entityPartyId;
    }
    return true;
  };

  static partyHasAnyOfProcessesOrSameParty(processes, partyId) {
    const hasProcess = this.checkPartyHasAnyOfProcesses(processes);
    const sameParty = this.checkSameParty(partyId);

    if (processes?.length > 0 && partyId) {
      //Zadani su i proces i partyId
      return hasProcess || sameParty;
    } else if (processes?.length > 0) {
      //Zadan je samo proces
      return hasProcess;
    } else if (partyId) {
      //Zadan je samo partyId
      return sameParty;
    } else {
      //Nije zadano nista
      return true;
    }
  }

  static renderElementByPermissions = (element, processes, partyId) => {
    if (this.partyHasAnyOfProcessesOrSameParty(processes, partyId)) {
      return element;
    }
  };

  static partyHasPermissionOnEntity = (entity, operation) => {
    const party = PartySession.getParty();
    if (entity.classificationIds && entity.classificationIds.length > 0) {
      const operationClassifications =
        party?.operationClassifications[operation];
      if (operation !== constants.OPERATION_READ) {
        return (
            operationClassifications != null &&
            entity.classificationIds.some(
                id => operationClassifications.indexOf(id) !== -1
            )
        );
      } else {
        return true;
      }

    } else {
      const authorities = party?.authorities;
      return CommonUtil.arrayHasObjectWithProperty(
        authorities,
        "authority",
        operation
      );
    }
  };

  static geClassificationsByOperation = operation => {
    const party = PartySession.getParty();
    if (party?.operationClassifications[operation]) {
      return party.operationClassifications[operation];
    } else return [];
  };
}

export default SecurityUtils;
